import React from "react";

// Predefined color per prefix
const COLORS = {
  "سوال": { bg: "#3B82F620", fg: "#1D4ED8" },
  "اعلان": { bg: "#DC262620", fg: "#991B1B" },
  "بحث": { bg: "#7C3AED20", fg: "#5B21B6" },
  "مدد": { bg: "#F59E0B20", fg: "#92400E" },
  "خبر": { bg: "#0891B220", fg: "#155E75" },
  "کہانی": { bg: "#DB277720", fg: "#9D174D" },
  "تجزیہ": { bg: "#059E6920", fg: "#065F46" },
};

export default function PrefixBadge({ prefix }) {
  if (!prefix) return null;
  const c = COLORS[prefix] || { bg: "#01411C20", fg: "#01411C" };
  return (
    <span
      className="urdu-naskh text-xs font-semibold rounded px-1.5 py-0.5"
      style={{ background: c.bg, color: c.fg, border: `1px solid ${c.fg}25` }}
      data-testid={`prefix-badge-${prefix}`}
    >
      {prefix}
    </span>
  );
}
